export enum CompanyServices {
    Bitdefender_MDR = 'bitdefender_mdr',
    MDR_Foundations = 'mdr_foundations',
    MDR_Foundations_for_MSP = 'mdr_msp_foundations',
    MDR_Core = 'mdr_core',
    Managed_Endpoint_Detection_and_Response = 'mdr',
    MDR_Enterprise = 'mdr_enterprise',
    MDR_Advanced = 'mdr_advanced',
    Bitdefender_MDR_PLUS = 'bitdefender_mdr_plus',
}

export enum CompanyPortalServices {
    Customerzone = 'cz',
    Mdr = 'mdr',
    Ti = 'bd-ti',
}

interface EnableModulesForAppInterface {
    name: string;
    defaultFor?: CompanyPortalServices[];
    allowed: CompanyPortalServices[];
}

interface ThemeConfig {
    logo: string;
    service: string;
}

export const themeConfig: ThemeConfig[] = [
    {
        logo: 'assets/images/logo/logo-light-cz.svg',
        service: CompanyPortalServices.Customerzone,
    },
    {
        logo: 'assets/images/logo/logo-light.svg',
        service: CompanyPortalServices.Mdr,
    },
];

export const APP_ALLOWED_MODULES: EnableModulesForAppInterface[] = [
    {
        name: 'dashboard',
        defaultFor: [CompanyPortalServices.Mdr],
        allowed: [CompanyPortalServices.Mdr],
    },
    {
        name: 'companies',
        allowed: [CompanyPortalServices.Customerzone, CompanyPortalServices.Mdr],
    },
    { name: 'users', allowed: [CompanyPortalServices.Customerzone, CompanyPortalServices.Mdr] },
    {
        name: 'support-tickets',
        defaultFor: [CompanyPortalServices.Customerzone],
        allowed: [CompanyPortalServices.Customerzone, CompanyPortalServices.Mdr],
    },
    { name: 'investigations', allowed: [CompanyPortalServices.Mdr] },
    { name: 'recommendations', allowed: [CompanyPortalServices.Mdr] },
    { name: 'customer-tasks', allowed: [CompanyPortalServices.Mdr] },
    { name: 'customer-verification-requests', allowed: [CompanyPortalServices.Mdr] },
    { name: 'threat-hunts', allowed: [CompanyPortalServices.Mdr] },
    { name: 'response-actions', allowed: [CompanyPortalServices.Mdr] },
    { name: 'documents', allowed: [CompanyPortalServices.Customerzone, CompanyPortalServices.Mdr] },
    { name: 'reports', allowed: [CompanyPortalServices.Mdr] },
    { name: 'monthly-report', allowed: [CompanyPortalServices.Mdr] },
    { name: 'emergency-contacts', allowed: [CompanyPortalServices.Mdr] },
    { name: 'pre-approved-actions', allowed: [CompanyPortalServices.Mdr] },
    {
        name: 'terms-and-conditions',
        allowed: [CompanyPortalServices.Mdr, CompanyPortalServices.Customerzone, CompanyPortalServices.Ti],
    },
    { name: 'companies-onboarding-issues', allowed: [CompanyPortalServices.Mdr] },
    { name: 'companies-offboarding-list', allowed: [CompanyPortalServices.Mdr] },
    { name: 'companies-monitoring-issues', allowed: [CompanyPortalServices.Mdr] },
    { name: 'companies-onboarding-history', allowed: [CompanyPortalServices.Mdr] },
    { name: 'cq', allowed: [CompanyPortalServices.Mdr] },
    { name: 'alerts-triaged', allowed: [CompanyPortalServices.Mdr] },
    { name: 'breach-warranty', allowed: [CompanyPortalServices.Mdr] },
    { name: 'notifications', allowed: [CompanyPortalServices.Mdr] },
];
